import axios from 'axios';
import env from '../../config';

export const lessonRescheduleAccept = async (
	{ lessonId, optionId }: { lessonId: string, optionId: string }
): Promise<void> => {
	await axios.post(env.endpoints.lessonRescheduleAccept, {
		lessonId, optionId,
	}, {
		headers: {
			'Content-Type': 'application/json',
		},
	})
	return ;

};
